import AccountAccessArea from "../enums/AccountAccessArea";

const VALID_AREA_VALUES = new Set(
    Object.keys(AccountAccessArea)
        .filter((k) => isNaN(Number(k)))
        .map((k) => String((AccountAccessArea as any)[k]))
);

export default function parsePermittedAreas(raw: any): string[] {
    if (raw == null) return [];

    let value: any = raw;

    let safety = 0;
    while (typeof value === "string" && safety < 3) {
        try {
            value = JSON.parse(value);
        } catch {
            return [];
        }
        safety++;
    }

    if (!Array.isArray(value)) return [];

    const stringified = value.map(String);
    const allValid = stringified.every((el) => VALID_AREA_VALUES.has(el));
    const isUnique = new Set(stringified).size === stringified.length;

    if (!allValid || !isUnique) {
        return [];
    }

    return stringified;
}